import { AxiosResponse } from "axios";

import api from "./api";

import serveRequestErrors from "common/serve-request-errors";

import ErrorResponseDto from "dto/services/error-response-dto";
import { SelectOption } from "dto/components/app-select-input-dto";

const getResourceTemplates = async (): Promise<AxiosResponse<{ content: SelectOption[] }>> => {
	let response = null;

	let errorMessage = "";

	try {
		const res = await api.get.resources.templates();

		const content = res.data.data.templates.map((o: string) => ({ label: o, value: o }));

		response = { ...res, data: { ...res.data, content: content } };
	} catch (error) {
		const err = error as Error | ErrorResponseDto;

		serveRequestErrors(err);
	}

	if (response) return response;

	throw errorMessage;
};

export default getResourceTemplates;
